<template>
    <div id="app">
        <a-locale-provider :locale="zh_CN">
            <layout>

            </layout>
        </a-locale-provider>
    </div>
</template>
<script>
import layout from "./layout/layout";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import moment from "moment";
moment.locale("zh-cn");
export default {
    name: "app",
    created() {},
    components: {
        layout
    },
    data() {
        return {
            zh_CN
        };
    },

    methods: {}
};
</script>


<style lang="scss">
.page_box {
    width: 100%;
    margin-bottom: 40px;

    .box_top {
        height: 34px;
        width: 100%;
        border-bottom: 3px solid #3686e3;
        margin-bottom: 10px;

        .box_title {
            display: inline-block;
            font-size: 18px;
            color: #333333;
            font-family: "SourceHanSansCN-Normal";
            margin-right: 30px;
            margin-bottom: 10px;
        }

        .box_tab {
            display: inline-block;
            height: 100%;
            font-size: 16px;
            margin-right: 29px; //兼容其他浏览器防止掉下来所以统一写小一点
            cursor: pointer;
        }
        .tsj {
            background: url("./assets/tsj.png") no-repeat 50% 22px;
        }

        .more {
            cursor: pointer;
            width: 80px;
            text-align: right;
            font-size: 16px;
            margin-top: 6px;
            background: url("./assets/more.png") no-repeat 12px 6px;
        }
    }
    .border_none {
        border-color: #b4b4b4;
    }

    .box_content {
        width: 100%;
        box-shadow: #b4b4b4 0px 0px 5px;
        padding: 0 10px;
    }
}

.last_content {
    margin-bottom: 40px;
}
</style>
